export default __webpack_public_path__ + "static/media/2408246.63fb5d9d.webp";